import React from "react";

const PaymentSuccessful = () => {
    return (
        <div className="flex items-center justify-center min-h-screen ">
            <div className="p-8 max-w-md w-full text-center">
                {/* Success Icon */}
                <div className="flex justify-center mb-6">
                    <div className="bg-green-100 rounded-full p-4">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-12 w-12 text-green-500"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M5 13l4 4L19 7"
                            />
                        </svg>
                    </div>
                </div>

                {/* Title */}
                <h1 className="text-2xl font-bold text-gray-800 mb-2">
                    Payment Successful
                </h1>

                {/* Description */}
                <p className="text-gray-600 mb-6">
                    Thank you for your payment! Your transaction has been completed
                    successfully.
                </p>

                {/* Action Button */}
                <button
                    onClick={() => (window.location.href = "/")}
                    className="bg-green-500 text-white px-6 py-2 rounded-md hover:bg-green-600 transition duration-200"
                >
                    Go to Home
                </button>
            </div>
        </div>
    );
};

export default PaymentSuccessful;
